import { css } from '@emotion/react';
import colors from 'config/color';

export const modalStyles = {
  width: 600,
  height: 500,
  overflowY: 'scroll',

  content: {
    padding: 32,
  },
};

export const containerStyles = css`
  display: flex;
  flex-direction: column;
`;

export const titleContainerStyles = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0 0 10px;

  button {
    background: ${colors.TRANSPARENT};
    border: none;
    width: fit-content;
    padding: 0;
  }

  span, i {
    color: ${colors.LIGHT_BLUE};
  }

  span {
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.01em;
  }

  i {
    font-size: 12px;
  }
`;

export const formRowContainerStyles = css`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 16px 0 0;
`;

export const fullColumnContainerStyles = css`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const halfColumnContainerStyles = css`
  width: calc(50% - 12px);
  display: flex;
  flex-direction: column;
`;

export const labelStyles = css`
  font-weight: 500;
  font-size: 14px;
  margin: 0 0 8px;
`;

export const inputStyles = css`
  width: calc(100% - 24px);
  padding: 12px;
  border: 1px solid ${colors.GREY};
  background: ${colors.WHITE};
  border-radius: 8px;
  font-size: 16px;
  height: 22px;
  border-outline: none;

  &:disabled {
    cursor: not-allowed;
    background: ${colors.GRAY};
  }
`;

export const selectContainerStyles = css`
  width: 100%;
`;

export const selectStyles = css`
  padding: 12px;
  width: 100%;
  border: 1px solid ${colors.GREY};
  background: ${colors.TRANSPARENT};
  border-radius: 8px;
  height: 48px;
`;

export const selectIconStyles = css`
  right: 10px;
  top: 20px;
`;

export const reactSelectContainerStyles = css`
  .company-name__control {
    height: 48px;
    border-radius: 8px;
  }

  .company-name__placeholder, .company-name__dropdown-indicator {
    color: ${colors.BLACK};
  }

  .company-name__indicator-separator {
    width: 0;
  }

  .css-tj5bde-Svg {
    height: 16px;
    width: 16px;
  }
`;

export const textareaStyles = css`
  width: calc(100% - 24px);
  height: auto;
  padding: 12px;
  border: 1px solid ${colors.GREY};
  border-radius: 8px;
  line-height: 20px;
  font-family: "Work Sans", sans-serif;
  font-size: 16px;
  outline: none;
  appearance: none;
  resize: none;
`;

export const buttonContainerStyles = css`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin: 16px 0 0;
`;

export const buttonStyles = css`
  background: ${colors.BLUE};
  color: ${colors.WHITE};
  width: 120px;
  padding: 10px 12px;
  border-color: ${colors.BLUE};
`;
